<template>
  <CForm @submit="submit">
    <CModal :title="$t('jobs.pause')" @close="close">
      <template #body>
        <CBooleanRadioField v-model="formData.willContinue" :label="$t('jobs.willContinue')" required/>

        <template v-if="formData.willContinue === false">
          <CField v-model="formData.pauseReason" type="radio" :options="pauseReasons" :label="$t('jobs.pauseReason')" required>
            <template #option="{ option }">
              {{ option.description }}
            </template>
          </CField>

          <CLargeCheckButton v-model="formData.needFollowUp">
            <CShelf align="top">
              <template #left>
                <div>
                  <p class="u-medium u-title u-mb-1">
                    {{ $t('jobs.followUpTitle') }}
                  </p>
                  <p>{{ $t('jobs.followUpDescription') }}</p>
                </div>
              </template>
              <template #right>
                <CFollowUpAppointmentBadge/>
              </template>
            </CShelf>
          </CLargeCheckButton>
        </template>
      </template>
    </CModal>
  </CForm>
</template>

<script setup lang="ts">
  import { computed, reactive } from 'vue';
  import { DossierId } from '@/dossier/models/AbstractDossier';
  import CModal from '@/general/components/CModal.vue';
  import CFollowUpAppointmentBadge from '@/shared/components/CFollowUpAppointmentBadge.vue';
  import CShelf from '@/shared/components/CShelf.vue';
  import CBooleanRadioField from '@/shared/components/form/CBooleanRadioField.vue';
  import CField from '@/shared/components/form/CField.vue';
  import CForm from '@/shared/components/form/CForm.vue';
  import CLargeCheckButton from '@/shared/components/form/CLargeCheckButton.vue';
  import Job from '../models/Job';
  import PauseJobData from '../models/PauseJobData';
  import JobService from '../services/JobService';

  const props = defineProps<{
    job: Job,
    dossierId: DossierId,
  }>();

  const emit = defineEmits<{ (e: 'close'): void }>();

  const formData = reactive({
    willContinue: null,
    pauseReason: null,
    needFollowUp: false,
  }) as PauseJobData;

  const pauseReasons = computed(() => {
    return JobService.getPauseReasons();
  });

  function submit() {
    JobService.pause(formData, props.job, props.dossierId);
    close();
  }

  function close() {
    emit('close');
  }

</script>